import { CommonModule } from "@angular/common";
import { Component, HostListener, Input } from "@angular/core";
import { CommonService } from "@shared/services/common.service";

@Component({
  selector: 'app-circle-background-icon',
  templateUrl: './circle-background-icon.component.html',
  styleUrls: ['./circle-background-icon.component.scss'],
  standalone: true,
  imports: [CommonModule]
})
export class CircleBackgroundIconComponent {
  @Input() icomoonClassName: string = '';
  @Input() iconSize: string = '50px';
  @Input() backgroundCircleDiameter: string = '120px';
  @Input() iconSizeMobile: string = '42px';
  @Input() backgroundCircleDiameterMobile: string = '100px';
  isMobile: boolean = false;

  @HostListener('window:resize', [])
  onResize() {
    if (this.cs.isBrowser) {
      this.isMobile = window.innerWidth <= 992;
    }
  }

  constructor(private readonly cs: CommonService) {
    this.onResize();
  }
}